import type { ReactNode } from "react";
import type { Observable } from "rxjs";

import type { MeetingParticipantRoles } from "graphql_globals";

import type { BeholderHeader_meetingParticipants as MeetingParticipant } from "../beholder/header/index_fragment.graphql";

export type LocalParty = {
  id: string;
  track: ReactNode;
  role: MeetingParticipantRoles;
  qualityChanged$: Observable<number> | null;
  volumeChanged$: Observable<number> | null;
  micEnabled: boolean;
  participants: MeetingParticipant[];
};

export type RemoteParty = LocalParty & {
  isDominantSpeaker: boolean;
  screenTrack: ReactNode;
  videoTrackDimensions: { width: number | null; height: number | null } | undefined;
  reconnecting: boolean | undefined;
  state: string | undefined;
};

export enum Modals {
  AV_SETTINGS = "AV_SETTINGS",
  CHAT = "CHAT",
  MENU = "MENU",
  NOTARY_DETAILS = "NOTARY_DETAILS",
  PARTICIPANTS_LIST = "PARTICIPANTS_LIST",
  DOC_UPLOAD = "DOC_UPLOAD",
}

export { default as MobileMeetingSigningControls } from "./signing_controls";
export { default as MobileMeetingContainer } from "./mobile_meeting_container";
export { default as MobileMeetingRemainingActions } from "./remaining_actions_banner";
